// Generated from the D01 shared identity-session contract. Do not edit generated copies.
// A cross-tab signal is only a request to query the server, never authentication evidence.
const CHANNEL = 'academy-identity-session-v1';
export function notifyIdentitySessionChange(): void {
  if (typeof BroadcastChannel === 'undefined') return;
  try {
    const channel = new BroadcastChannel(CHANNEL);
    channel.postMessage({ version: 1, type: 'identity-changed' });
    channel.close();
  } catch { /* Focus and visibility revalidation remain available. */ }
}

export function watchIdentitySession(
  check: (isCurrent: () => boolean) => Promise<void>,
  onError: (error: unknown) => void,
): () => void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return () => {};
  let active = true;
  let pending = false;
  let attemptedAt = 0;
  const revalidate = () => {
    if (!active || pending || document.visibilityState === 'hidden' || Date.now() - attemptedAt < 1000) return;
    pending = true;
    attemptedAt = Date.now();
    void check(() => active).catch(error => { if (active) onError(error); }).finally(() => { pending = false; });
  };
  let channel: BroadcastChannel | undefined;
  try {
    if (typeof BroadcastChannel !== 'undefined') {
      channel = new BroadcastChannel(CHANNEL);
      channel.onmessage = event => {
        if (event.data?.version === 1 && event.data?.type === 'identity-changed') revalidate();
      };
    }
  } catch { /* Browsers can disable cross-tab messaging. */ }
  window.addEventListener('focus', revalidate);
  window.addEventListener('pageshow', revalidate);
  document.addEventListener('visibilitychange', revalidate);
  const timer = window.setInterval(revalidate, 60_000);
  return () => {
    active = false;
    window.clearInterval(timer);
    channel?.close();
    window.removeEventListener('focus', revalidate);
    window.removeEventListener('pageshow', revalidate);
    document.removeEventListener('visibilitychange', revalidate);
  };
}
